import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b6ec418"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "picker" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("选择岗位")
const _hoisted_4 = { class: "placeholder" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("选择岗位")
const _hoisted_7 = { class: "placeholder" }
const _hoisted_8 = { style: {"margin-top":"5px"} }
const _hoisted_9 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_post_picker = _resolveComponent("post-picker", true)!
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.mode === 'DESIGN')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_el_button, {
            disabled: "",
            icon: "Briefcase",
            type: "primary",
            size: "default",
            round: ""
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.placeholder), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (!_ctx.readerMode)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_el_button, {
                  icon: "Briefcase",
                  type: "primary",
                  size: "default",
                  round: "",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$refs.postPicker.modalOpen()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }),
                _createVNode(_component_post_picker, {
                  ref: "postPicker",
                  multiple: _ctx.multiple,
                  selected: _ctx._value,
                  onOk: _ctx.selected
                }, null, 8, ["multiple", "selected", "onOk"]),
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.placeholder), 1),
                _createElementVNode("div", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx._value, (post, i) => {
                    return (_openBlock(), _createBlock(_component_el_tag, {
                      key: i,
                      size: "default",
                      style: {"margin":"5px"},
                      closable: "",
                      onClose: ($event: any) => (_ctx.delPost(i))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(post.title), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClose"]))
                  }), 128))
                ])
              ], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx._value, (post, i) => {
                  return (_openBlock(), _createBlock(_component_el_tag, {
                    key: i,
                    size: "default",
                    style: {"margin":"5px"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(post.title), 1)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]))
        ]))
  ]))
}